import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

let init = false;
let swiper;
function swiperCard() {
    if (window.innerWidth <= 768) {
        if (!init) {
            init = true;
            swiper = new Swiper('#js-product-gallery', {
                modules: [Navigation],
                slidesPerView: 1,
                navigation: {
                    prevEl: '.js-swiper-button-prev',
                    nextEl: '.js-swiper-button-next',
                },
            });
        }
    } else if (init) {
        swiper.destroy();
        init = false;
    }
}
swiperCard();
window.addEventListener('resize', swiperCard);
